/* eslint-disable no-console */
import { initializeApp } from 'firebase/app';
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from 'firebase/app-check';

import { getAnalytics, setUserId, logEvent } from 'firebase/analytics';

import {
  FIREBASE_APIKEY,
  FIREBASE_APPID,
  FIREBASE_AUTHDOMAIN,
  FIREBASE_MEASUREMENTID,
  FIREBASE_MESSAGINGSENDERID,
  FIREBASE_PROJECTID,
  FIREBASE_STORAGEBUCKET,
  FIREBASE_RECAPTCH_APIKEY,
} from '@portal/config/env';
import { PageClass } from '@portal/enum/analytics';

const reCaptchaKey =
  typeof FIREBASE_RECAPTCH_APIKEY === 'string' &&
  FIREBASE_RECAPTCH_APIKEY.trim() !== ''
    ? FIREBASE_RECAPTCH_APIKEY.trim()
    : undefined;

const firebaseConfig = {
  apiKey: FIREBASE_APIKEY,
  authDomain: FIREBASE_AUTHDOMAIN,
  projectId: FIREBASE_PROJECTID,
  storageBucket: FIREBASE_STORAGEBUCKET,
  messagingSenderId: FIREBASE_MESSAGINGSENDERID,
  appId: FIREBASE_APPID,
  measurementId: FIREBASE_MEASUREMENTID,
  reCaptchaKey,
};

export const app = initializeApp(firebaseConfig);

export const analytics = getAnalytics(app);

let appCheck: ReturnType<typeof initializeAppCheck> | null = null;

const initAppCheck = () => {
  if (!reCaptchaKey) {
    if (typeof console !== 'undefined' && console.warn) {
      console.warn(
        '[Firebase] App Check skipped: VITE_FIREBASE_RECAPTCH_APIKEY is missing or empty. Set it in .env and restart the dev server.'
      );
    }
    return;
  }
  const isLocalhost =
    typeof window !== 'undefined' && window.location?.hostname === 'localhost';
  const useDebug =
    import.meta.env.VITE_APP_CHECK_DEBUG === 'true' || isLocalhost;
  if (useDebug && typeof self !== 'undefined') {
    (
      self as unknown as { FIREBASE_APPCHECK_DEBUG_TOKEN?: boolean }
    ).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }
  try {
    appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(reCaptchaKey),
      isTokenAutoRefreshEnabled: true,
    });
  } catch (err) {
    if (typeof console !== 'undefined' && console.warn) {
      console.warn('[Firebase] initializeAppCheck failed:', err);
    }
  }
};
initAppCheck();

export { appCheck };

export const setAnalyticsUserId = (id: string | null) =>
  Promise.all([setUserId(analytics, id ?? '')]);

export const sendEvent = (
  eventType?: string,
  params?: {
    firebase_page: string;
    firebase_page_class: PageClass;
  }
) => logEvent(analytics, eventType ?? 'page_view', params);
